import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArticleCard from "@/components/ArticleCard";
import EditorialEmptyState from "@/components/EditorialEmptyState";
import { api } from "@/lib/api";

export default function InsightsSection() {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    api.get("/articles").then((response) => setArticles(response.data.slice(0, 3))).catch(() => setArticles([]));
  }, []);

  return (
    <section id="insights" data-testid="ugi-insights-section" className="border-t border-[#E5DFD3] bg-[#FDFBF7]">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
        <div className="mb-14 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#C5A059]">UGI Insights</p>
            <h2 className="mt-5 max-w-2xl font-serif text-3xl font-normal leading-tight tracking-[-0.02em] text-[#1C1613] sm:text-4xl">
              An editorial space for trade intelligence.
            </h2>
          </div>
          <Link data-testid="insights-view-all-link" to="/insights" className="w-max border border-[#1C1613] px-5 py-3 text-[11px] font-bold tracking-[0.16em] text-[#1C1613] transition-colors hover:bg-[#1C1613] hover:text-[#FDFBF7]">
            VIEW INSIGHTS
          </Link>
        </div>
        {articles === null && <div className="border border-[#E5DFD3] p-10 font-serif text-3xl">Loading insights...</div>}
        {articles?.length === 0 && <EditorialEmptyState />}
        {articles?.length > 0 && (
          <div className="grid gap-8 md:grid-cols-3">
            {articles.map((article) => <ArticleCard key={article.id} article={article} testId={`home-article-card-${article.slug}`} />)}
          </div>
        )}
      </div>
    </section>
  );
}
